<template>
  <div class="Features">
    <div class="main">
      <p class="title">让数据更智慧</p>
      <p class="sub_title">成为行业最佳数据解决方案供应商</p>

      <ul class="items">
        <li class="item" v-for="feature,index in features">
          <img :src="feature.imgUrl" />
          <p class="title">{{feature.title}}</p>
          <p class="remark">{{feature.remark}}</p>
        </li>
      </ul>

    </div>
  </div>
</template>

<script>
  export default {
    name: 'Features',
    data() {
      return {
        features: [
          {imgUrl: require("@/assets/imgs/img-home-jzg-01.png"),title:"客户第一",remark:"深入客户、服务客户、成就客户"},
          {imgUrl: require("@/assets/imgs/img-home-jzg-02.png"),title:"团队合作",remark:"包容互助、共担共享、一起成就"},
          {imgUrl: require("@/assets/imgs/img-home-jzg-03.png"),title:"教学相长",remark:"专注专业、虚心请教、主动分享"},
          {imgUrl: require("@/assets/imgs/img-home-jzg-04.png"),title:"简化",remark:"诚实正直、直言不讳、结果导向"},
          {imgUrl: require("@/assets/imgs/img-home-jzg-05.png"),title:"激情",remark:"热爱工作、积极生活、挑战困难"},
          {imgUrl: require("@/assets/imgs/img-home-jzg-06.png"),title:"创新",remark:"善于学习、拥抱变化、创造变化"},
        ]
      }
    },
    mounted() {
      $('.Features ul li').addClass("active");
      var screenHeight =  document.documentElement.clientHeight
      setTimeout(function() {
        window.onscroll = function() {
          var bool = $(window).scrollTop()+$(window).height()==$(document).height();
          var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
          let fontSize = getComputedStyle(window.document.documentElement)['font-size'];

          var lis = $('.Features ul li')
          for(var i =0;i<lis.length;i++) {
            var offsetTop = $(lis[i]).offset().top
            if(offsetTop - scrollTop - screenHeight < 0 && !bool && !$(lis[i]).hasClass('active')) {
              $(lis[i]).addClass('active')
            }
          }
        }
      },100)
    }
  }
</script>

<style scoped lang="scss" type="text/scss">
  @import '../../assets/css/animation.css';
  .Features {
    width: 100%;
    padding-bottom: 60px;

    .main {
      width: 1200px;
      margin: 0 auto;
      p {
        margin: 0;
      }
      >.title {
        height:50px;
        font-size:40px;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(0,0,0,1);
        text-align: center;
        margin-top: 59px;
      }
      >.sub_title {
        height:40px;
        font-size:30px;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(0,0,0,1);
        text-align: center;
        margin: 19px 0 70px;
      }

      .items {
        margin: 0;
        display: inline-block;
        padding-left: 80px;

        .item {
          width: 280px;
          list-style: none;
          float: left;
          margin-bottom: 50px;
          opacity: 0;
          transform:RotateY(90deg);
          -ms-transform:RotateY(90deg); 	/* IE 9 */
          -moz-transform:RotateY(90deg); 	/* Firefox */
          -webkit-transform:RotateY(90deg); /* Safari 和 Chrome */
          -o-transform:RotateY(90deg); 	/* Opera */
          &.active{
            -moz-animation: RotateY 0.5s linear forwards;
            -ms-animation: RotateY 0.5s linear forwards;
            -webkit-animation: RotateY 0.5s linear forwards;
            -o-animation: RotateY 0.5s linear forwards;
            animation: RotateY 0.5s linear forwards;
          }
          p{
            text-align: center;
          }

          >img {
            width: 280px;
            height: 200px;
            border-radius: 8px;
          }
          >.title {
            height:30px;
            font-size:24px;
            font-family:PingFangSC-Medium;
            font-weight:500;
            color:rgba(0,0,0,1);
            margin-top: 38px;
          }
          >.remark {
            height:25px;
            font-size:18px;
            font-family:PingFangSC-Medium;
            font-weight:500;
            color:rgba(136,136,136,1);
            margin: 12px 0;
          }
        }
        .item:nth-of-type(2),
        .item:nth-of-type(5) {
          margin: 0 100px;
        }
      }

    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Home/Features.vue